<wa-dialog label="parameter set name" open="true" lightDismiss=false withoutHeader=true withFooter="true">
  <div class="wa-stack">
    <h3 class="wa-heading-m">Choose a name for the new parameter set:</h3>
    <wa-input type="text"
              [formControl]="name"
              placeholder="parameter set name"></wa-input>
    @if (name.touched && name.hasError('nameAlreadyExists')) {
      <span>Name already exists. Please choose a different name.</span>
    }
  </div>
  <div slot="footer" class="wa-cluster">
    <wa-button variant="danger" appearance="filled" (click)="cancel()">Cancel</wa-button>
    @if (name.valid) {
      <wa-button
        variant="brand"
        appearance="filled"
        (click)="confirm()">
        Select
      </wa-button>
    } @else {
      <wa-button
        variant="brand"
        appearance="filled"
        [disabled]="true"
        (click)="confirm()">
        Select
      </wa-button>
    }
  </div>
</wa-dialog>
